import React from 'react';
import { createRoot } from 'react-dom/client';
import process from 'process/browser';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

if (typeof window !== 'undefined' && !window.process) {
  window.process = process;
}

// Keep runtime failures visible. Suppressing every window error/rejection made
// API, WebSocket and stale-cache failures look like silent loading problems.
window.addEventListener('error', function(e) {
  console.error('Unhandled window error:', e.error || e.message || e);
});

window.addEventListener('unhandledrejection', function(e) {
  console.error('Unhandled promise rejection:', e.reason || e);
});

// Override console.error to prevent crashes on build
const originalConsoleError = console.error;
console.error = (...args) => {
  // Filter out specific React errors that might stop the build
  const errorString = args.join(' ');
  if (
    errorString.includes('Warning:') || 
    errorString.includes('ReactDOM.render is no longer supported') ||
    errorString.includes('findDOMNode') ||
    errorString.includes('is deprecated in StrictMode')
  ) {
    console.warn('Suppressed React warning:', ...args);
    return;
  }
  originalConsoleError(...args);
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// This project has no generated offline precache manifest. Always remove any
// old service worker so a previous bundle cannot keep serving stale game code.
serviceWorker.unregister();
if ('caches' in window) {
  window.caches.keys().then(keys => Promise.all(
    keys.filter(key => /ludo|workbox|precache/i.test(key)).map(key => window.caches.delete(key))
  )).catch(() => {});
}
